import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class AdminContestsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('contest');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
